import { Routes } from '@angular/router';
import { CeMarkContentResolver, DataProcessingInfoContentResolver, FaqContentResolver, PatientProfileContentResolver, CookiePolicyContentResolver, PrivacyPolicyContentResolver } from './shared/services/resolver.service';
import { authGuard, notAuthGuard } from './shared/guards/can-activate/auth.guard';
import { consentGuard, consentRequiredGuard } from './shared/guards/can-activate/consent.guard';
import { canMatchDoctor, canMatchPatient } from './shared/guards/can-match/usertype-match.guard';
import { SchemasComponent } from './schemas/schemas.component';
import { TestLoginComponent } from './auth/test-login/test-login.component';
import { AuthComponent } from './auth/auth.component';
import { SigninComponent } from './auth/signin/signin.component';
import { LoginComponent } from './auth/login/login.component';
import { LogoutComponent } from './auth/logout/logout.component';
import { SingleLogoutComponent } from './auth/single-logout/single-logout.component';
import { LoggedOutComponent } from './auth/logged-out/logged-out.component';
import { SchemaComponent } from './schemas/schema/schema.component';
import { ClinicProfileComponent } from './clinic-profile/clinic-profile.component';
import { PatientProfilePageComponent } from './patient-profile/patient-profile.component';
import { AuthenticatedComponent } from './authenticated/authenticated.component';
import { ReceptionComponent } from './authenticated/reception/reception.component';
import { CookiePrivacyPolicyComponent } from './cookie-privacy-policy/cookie-privacy-policy.component';
import { LoginGuidComponent } from './auth/login-guid/login-guid.component';

export const routes: Routes = [
    //{ path: '**', component: PageNotFoundComponent },
    {
        path: 'faq',
        title: 'Spørgsmål og svar | Web-patient',
        resolve: { faqContent: FaqContentResolver },
        loadComponent: () => import("./faq/faq.component").then(m => m.FaqComponent),
    },
    {
        path: 'faq/:group',
        title: 'Spørgsmål og svar | Web-patient',
        loadComponent: () => import("./faq/faq-group/faq-group.component").then(m => m.FaqGroupComponent),
    },
    {
        path: 'ce-mark',
        title: 'CE-mærket | Web-patient',
        resolve: { ceContent: CeMarkContentResolver },
        loadComponent: () => import("./ce-marked/ce-marked.component").then(m => m.CEMarkedComponent),
    },
    {
        path: 'cookie-and-privacy-policy',
        title: 'Cookies & privatlivspolitik | Web-patient',
        component: CookiePrivacyPolicyComponent
    },
    {
        path: 'cookiepolicy',
        title: 'Cookiespolitik | Web-patient',
        resolve: { cookiePolicyContent: CookiePolicyContentResolver },
        loadComponent: () => import("./cookie-privacy-policy/cookiepolicy/cookiepolicy.component").then(m => m.CookiepolicyComponent),
    },
    {
        path: 'privacypolicy',
        title: 'Privatlivspolitik | Web-patient',
        resolve: { privacyPolicyContent: PrivacyPolicyContentResolver },
        loadComponent: () => import("./cookie-privacy-policy/privacypolicy/privacypolicy.component").then(m => m.PrivacypolicyComponent),
    },
    { path: 'account/loginguid/:option', title: 'Arkiv | Web-patient', component: LoginGuidComponent },
    { path: 'auth/singleLogout', title: 'Logout | Web-patient', component: SingleLogoutComponent },
    { path: 'schemaaccess', pathMatch: 'full', redirectTo: 'auth/login' },
    /* Guarded routes */
    {
        path: '', canActivateChild: [notAuthGuard], children: [
            { path: '', pathMatch: "full", redirectTo: "/welcome" },
            { path: 'auth', title: 'Auth | Web-patient', component: AuthComponent },
            { path: 'auth/signin', title: 'Signin | Web-patient', component: SigninComponent },
            { path: 'auth/login', title: 'Login | Web-patient', component: LoginComponent },
            { path: 'auth/testlogin/:option', title: 'Test login | Web-patient', component: TestLoginComponent },
            {
                path: 'welcome',
                title: 'Velkommen til Web-patient',
                loadComponent: () => import("./welcome/welcome.component").then(m => m.WelcomeComponent),
            },
        ]
    },
    {
        path: '', canActivateChild: [authGuard], children: [
            { path: 'authenticated', title: 'authenticated', component: AuthenticatedComponent },
            { path: 'auth/logout', title: 'Logout | Web-patient', component: LogoutComponent },
            { path: 'auth/logged-out', title: 'Logging out | Web-patient', component: LoggedOutComponent },
            {
                path: 'data-processing-info',
                title: 'Information om databehandling',
                canActivate: [consentRequiredGuard],
                canMatch: [canMatchPatient],
                resolve: { dataProcessingInfoContent: DataProcessingInfoContentResolver },
                loadComponent: () => import("./data-processing-info/data-processing-info.component").then(m => m.DataProcessingInfoComponent),
            },
            {
                path: '', canActivateChild: [consentGuard], children: [
                    { path: 'schemas', title: 'Skemaer | Web-patient', component: SchemasComponent },
                    { path: 'reception', title: 'Reception | Web-patient', component: ReceptionComponent },
                    { path: 'schema/:schemaid', title: 'Skema | Web-patient', component: SchemaComponent },
                    {
                        path: 'clinic',
                        canMatch: [canMatchDoctor],
                        title: 'Klinik | Web-patient',
                        component: ClinicProfileComponent
                    },
                    {
                        path: 'profile',
                        canMatch: [canMatchPatient],
                        title: 'Min profil | Web-patient',
                        resolve: { patientProfileContent: PatientProfileContentResolver },
                        component: PatientProfilePageComponent
                    }
                ]
            },
        ]
    }
];
